import { isNil } from 'lodash'

/**
 * 数値を桁数に合うようにゼロパディングします。
 *
 * @param {number|string} num 数値
 * @param {number} [length=2] 桁数
 * @returns {string} ゼロパディングされた文字列
 */
export function padZero(num, length = 2) {
  return !isNil(num) ? String(num).padStart(length, '0') : num
}

/**
 * 渡された数値で範囲を表現します。
 *
 * @param {number} minAvailableSeat 最小席数
 * @param {number} maxAvailableSeat 最大席数
 * @param {number=minAvailableSeat} min 最小値
 * @param {number=maxAvailableSeat} max 最大値
 * @returns {string} 範囲で表現された文字列
 */
export const formatRange = ({ minAvailableSeat, maxAvailableSeat, min = minAvailableSeat, max = maxAvailableSeat }) =>
  min === max ? `${min}` : `${min}〜${max}`

/**
 * 閾値を超えた数値に超過記号を付記します。
 *
 * @param {number} value 値
 * @param {number} [max=99] 閾値
 * @param {string} [exceedStr=+] 超過記号
 */
export function formatExceed(value, max = 99, exceedStr = '+') {
  return value > max ? `${max}${exceedStr}` : value
}

/**
 * 数値を3桁区切りの文字列に変換する
 * @param {number|string} value 数値
 */
export const numberFormat = value => Math.round(Number(value)).toLocaleString()

/**
 * 割合を指定した小数位に揃える
 * @param {number|string} value 数値
 * @param {number} fixedDigit 小数位
 */
export const rateFormat = (value, fixedDigit = 1) => Number.parseFloat(value).toFixed(fixedDigit)

/**
 * 乱数を作成する
 * @param {number} max 最大値
 * @param {Function} rounding 丸め処理
 */
export const random = (max, rounding = Math.round) => rounding(Math.random() * Math.floor(max))

/**
 * 連続する数値配列を作成する
 * @param {number} len 長さ
 * @param {number} start 開始
 */
export const range = (len, start = 0) => [...Array(len).keys()].map(v => v + start)
